import { toOptions } from '../utils/labels';

export type Role = 'owner' | 'office' | 'worker';

export const ROLES: Record<Role, string> = { owner: 'Owner', office: 'Office staff', worker: 'Worker' };
export const ROLE_OPTIONS = toOptions(ROLES);
